/**
 * GA4 analytics: init, page views, events, user ID.
 * No-op when REACT_APP_GA4_MEASUREMENT_ID is not set.
 */

let measurementId = null;

function hasGtag() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * Initialize GA4. Loads gtag.js and configures with send_page_view: false for SPA.
 * @param {string} id - GA4 Measurement ID (e.g. G-XXXXXXXXXX)
 */
export function init(id) {
  if (typeof window === 'undefined' || !id) return;
  measurementId = id;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  script.onload = () => {
    window.gtag('js', new Date());
    window.gtag('config', id, { send_page_view: false });
  };
  document.head.appendChild(script);
}

/**
 * Send a page_view event (for SPA route changes).
 * @param {string} path - page_path
 * @param {string} title - page_title
 */
export function pageView(path, title) {
  if (!hasGtag()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document?.title || '',
  });
}

/**
 * Send a custom event.
 * @param {string} name - Event name
 * @param {Object} params - Optional event parameters
 */
export function event(name, params = {}) {
  if (!hasGtag()) return;
  window.gtag('event', name, params);
}

/**
 * Set user_id for GA4 (call after login).
 * @param {string|number} userId - Stable user identifier
 */
export function setUserId(userId) {
  if (!hasGtag() || !measurementId) return;
  window.gtag('config', measurementId, { user_id: String(userId) });
}
